export abstract class BaseModel {

    public abstract id: string;

}